// File generated from our OpenAPI spec
import { StripeResource } from '../../StripeResource.js';
const stripeMethod = StripeResource.method;
export const PaymentEvaluations = StripeResource.extend({
    create: stripeMethod({
        method: 'POST',
        fullPath: '/v1/radar/payment_evaluations',
    }),
});
